// Importing required components and modules
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import PurchaseCss from "./PurchaseDetails.module.css";
import { vendorDetails } from "../../../serviceFile/ApiService.js";

// Define the EventList component
const PurchaseDetails = () => {
  const [searchValue, setSearchValue] = useState("");
  const isSmDown = useMediaQuery("(max-width: 900px)");
  const [page, setPage] = useState(1);
  const [data, setData] = useState();
  const [vendorDetail, setVendorDetail] = useState();
  const rowsPerPage = 12;
  const navigate = useNavigate();

  // Api call to fetch vendor details
  useEffect(() => {
    vendorDetails().then((res) => {
      console.log(res?.data, "response");
      setVendorDetail(res?.data);
      setData(res?.data?.po_list);
    });
  }, []);

  // Functions to change pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Function for navigate to detail page
  const handlePoDetailPage = (poId) => {
    const indexValue = data?.findIndex((po) => po.PO === poId);
    navigate(`/Dashboard/PoDetails?poNo=${poId}&index=${indexValue}`);
  };

  // Handle search value
  const handleSearch = (name, e) => {
    const value = e.target?.value;
    setSearchValue(value);
    setPage(1);
  };

  // Search function
  const filteredData = data?.filter((row) =>
    Object.values(row)?.some(
      (field) =>
        typeof field === "string" &&
        field.toLowerCase().includes(searchValue?.toLowerCase())
    )
  );

  // JSX code for rendering the Purchase List component
  return (
    <>
      <Helmet>
        <title>Vendor details</title>
      </Helmet>
      {/* The main container */}
      <Box
        sx={{
          width: "100%",
          marginBottom: isSmDown ? "70px" : "19px",
          marginTop: "60px",
          display: "flex",
        }}
      >
        <Stack
          direction={isSmDown ? "column" : "row"}
          spacing={3}
          width="100%"
          sx={{ padding: isSmDown ? "0" : "30px" }}
        >
          <Stack
            sx={{
              width: isSmDown ? "100%" : "22%",
              borderRadius: "10px",
            }}
            className={PurchaseCss.profileCard}
          >
            <Stack className={PurchaseCss.coverImage}>
              <img src="/assets/images/Fact.jpeg" alt="cover" />
            </Stack>
            <Stack
              sx={{
                padding: "20px",
                marginTop: "20px",
                borderRadius: "10px",
                marginRight: "50px",
              }}
              className={PurchaseCss.profileDetailsCard}
            >
              <Typography
                variant="h6"
                sx={{
                  height: "100%",
                  color: "darkslategray",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                }}
              >
                Vendor Details
              </Typography>
              <Divider />
              <Stack spacing={2} sx={{ marginTop: "40px" }}>
                {/* Vendor Name */}
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                  }}
                  spacing={2}
                >
                  <img
                    style={{ width: "35px", height: "36px" }}
                    src="/assets/images/PersonIcon.jpg"
                    alt="Person Icon"
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 550, wordBreak: "break-word" }}
                  >
                    Name: {vendorDetail?.vendor_name}
                  </Typography>
                </Stack>
                {/* Phone Number */}
                <Stack
                  direction="row"
                  sx={{ alignItems: "center" }}
                  spacing={2}
                >
                  <img
                    style={{ width: "35px", height: "36px" }}
                    src="/assets/images/phone-icon-glossy.webp"
                    alt="Phone icon"
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 550, wordBreak: "break-word" }}
                  >
                    Phone number: {vendorDetail?.mobile}
                  </Typography>
                </Stack>
                {/* Email ID */}
                <Stack
                  direction="row"
                  sx={{ alignItems: "center" }}
                  spacing={2}
                >
                  <img
                    style={{ width: "35px", height: "36px" }}
                    src="/assets/images/mail-image.webp"
                    alt="Mail icon"
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 550, wordBreak: "break-word" }}
                  >
                    Email id: {vendorDetail?.email}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            sx={{
              width: isSmDown ? "100%" : "78%",
              padding: "20px",
              marginTop: "20px",
              borderRadius: "10px",
              marginRight: "50px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              // background:
              //   "linear-gradient(to right, #88d1fc, #ffffff, #9ad8f7, #ffffff, #88d1fc)",
            }}
            className={PurchaseCss.purchaseTableCard}
          >
            {/* Top section containing the Filter button */}
            <Stack
              direction={isSmDown ? "column" : "row"}
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  color: "darkslategray",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                }}
              >
                purchase details
              </Typography>
              <TextField
                id="outlined-basic"
                label="Search"
                variant="outlined"
                autoComplete="off"
                type="text"
                size="small"
                margin="dense"
                sx={{
                  width: "300px",
                  marginBottom: "10px",
                }}
                onChange={(e) => handleSearch("search", e)}
                InputProps={{
                  shrink: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon style={{ color: "rgb(64, 132, 255) " }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack spacing={1}>
              <Container>
                <Grid container spacing={2}>
                  {filteredData?.length > 0 &&
                    filteredData
                      ?.slice(
                        (page - 1) * rowsPerPage,
                        (page - 1) * rowsPerPage + rowsPerPage
                      )
                      .map((value, index) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            key={value.PO}
                          >
                            <Card
                              title="View Details"
                              sx={{
                                height: isSmDown ? "170px" : "140px",
                                cursor: "pointer",
                                borderRadius: "10px",
                                backgroundRepeat: "no-repeat",
                                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.0)",
                                boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                                backgroundSize: "cover",
                                "&:hover": {
                                  transition: "transform 300ms",
                                  transform: "scale(1.035)",
                                },
                                backgroundImage:
                                  index % 2 === 0
                                    ? "url(/assets/images/blue-chips.png)"
                                    : "url(/assets/images/card-background.jpeg)",
                                backgroundColor:
                                  index % 2 === 0
                                    ? "#f2f2f2"
                                    : "rgb(242, 240, 240)",
                              }}
                              onClick={() => handlePoDetailPage(value?.PO)}
                            >
                              {/* rgb(47, 136, 140)
                            rgb(64, 173, 191)
                            antiquewhite
                            rgb(242, 240, 240) */}
                              <Stack
                                direction="row"
                                sx={{
                                  display: "flex",
                                  justifyContent:
                                    index % 2 === 0 ? "end" : "start",
                                }}
                              >
                                <IconButton title="View details">
                                  <InfoIcon color="info" />
                                </IconButton>
                              </Stack>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "start",
                                  marginLeft: "20px",
                                }}
                              >
                                <Stack direction="column">
                                  <Stack
                                    direction="row"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        color: "steelblue",
                                        fontWeight: 600,
                                      }}
                                    >
                                      PO No:
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "steelblue",
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        overflow: "hidden",
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        maxWidth: 200,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                      }}
                                      title={value?.PO}
                                    >
                                      {value?.PO}
                                    </Typography>
                                  </Stack>
                                  {value?.GEM && (
                                    <Stack
                                      direction="row"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          color: "steelblue",
                                          fontWeight: 600,
                                        }}
                                      >
                                        Gem No:
                                      </Typography>
                                      <Typography
                                        sx={{
                                          color: "steelblue",
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                          overflow: "hidden",
                                          whiteSpace: "pre-wrap",
                                          wordWrap: "break-word",
                                          maxWidth: 200,
                                          display: "-webkit-box",
                                          WebkitLineClamp: 3,
                                          WebkitBoxOrient: "vertical",
                                        }}
                                        title={value?.GEM}
                                      >
                                        {value?.GEM}
                                      </Typography>
                                    </Stack>
                                  )}
                                </Stack>
                              </Box>
                            </Card>
                          </Grid>
                        );
                      })}
                </Grid>
              </Container>
            </Stack>
            {(filteredData?.length <= 0 ||
              filteredData?.length === undefined) && (
              <Stack
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <img
                  src="/assets/images/no-data.avif"
                  alt="No data Available"
                  style={{
                    width: isSmDown ? "359px" : "400px",
                    height: isSmDown ? "379px" : "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                ></img>
              </Stack>
            )}
            {filteredData?.length > 0 && (
              <Stack
                sx={{
                  alignItems: "flex-end",
                  marginTop: "8px !important",
                  marginRight: "20px",
                }}
              >
                <Pagination
                  siblingCount={0}
                  count={
                    filteredData.length <= 12
                      ? 1
                      : Math.ceil(filteredData.length / 12)
                  }
                  page={page}
                  onChange={handleChangePage}
                  color="primary"
                  variant="text"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </Stack>
        </Stack>
      </Box>
    </>
  );
};
export default PurchaseDetails;
